import * as mutations from './mutations'
// import * as getters from './getters'
import * as actions from './actions'

export default{
  namespaced: true,
  state () {
    return {
      limit: 10,
      sort: undefined,
      more: undefined,
      searching: false,
      searched: false
    }
  },
  mutations,
  actions
  // getters
}
